import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {Box, Button, Card, CardContent, CardHeader, Divider, makeStyles, TextField} from '@material-ui/core';
import {Alert} from "@material-ui/lab";
import axios from "axios";

const useStyles = makeStyles(({
    root: {}
}));

const WithdrawalForm = ({className, ...rest}) => {
    const classes = useStyles();
    const [values, setValues] = useState({
        amount: ''
    });
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    };

    const handleSend = () => {
        if (values.amount !== '' && values.password !== '' && values.confirm !== '') {
            if (values.amount > 0) {
                const body = {amount: -Number.parseFloat(values.amount)};
                axios.post("smartPiggy/moneyLogWithUser", body).then(response => {
                    setError(null);
                    setMessage("Withdrawal notice has been created.");
                    setValues({ amount: '' });
                }).catch(err => {
                    if (err.response) {
                        let {message} = err.response.data;
                        if (message)
                            setError(message)
                        else
                            setError("Something went wrong, try it later.")
                    } else {
                        setError("Something went wrong, try it later.")
                    }
                    setMessage(null);
                    setValues({ amount: '' });
                });
            } else {
                setError("Please enter correct value");
                setMessage(null);
            }
        } else {
            setError("Please fill all field");
            setMessage(null);
        }
    }

    return (
        <form className={clsx(classes.root, className)} {...rest} >
            <Card>
                <CardHeader
                    subheader="Withdrawal Request"
                />
                <Divider/>
                <CardContent>
                    {message && <Alert severity="success">{message}</Alert>}
                    {error && <Alert severity="error">{error}</Alert>}
                    <TextField
                        fullWidth
                        label="Amount"
                        margin="normal"
                        name="amount"
                        onChange={handleChange}
                        type="number"
                        value={values.amount}
                        variant="outlined"
                    />
                </CardContent>
                <Divider/>
                <Box display="flex" justifyContent="flex-end" p={2}>
                    <Button color="primary" variant="contained" onClick={handleSend}> Send </Button>
                </Box>
            </Card>
        </form>
    );
};

WithdrawalForm.propTypes = {
    className: PropTypes.string
};

export default WithdrawalForm;
